export const GET_USER = 'GET_USER';
export const SET_USER = 'SET_USER';

// ORGANIZATONS
export const ORGANIZATION_SEARCH_REQUESTED = 'ORGANIZATION_SEARCH_REQUESTED';
export const ORGANIZATION_SEARCH_SUCCEEDED = 'ORGANIZATION_SEARCH_SUCCEEDED';
export const ORGANIZATION_SEARCH_FAILED = 'ORGANIZATION_SEARCH_FAILED';
export const ORGANIZATION_FIND_BY_TERM_SEARCH_REQUESTED = 'ORGANIZATION_FIND_BY_TERM_SEARCH_REQUESTED';
export const ORGANIZATION_FIND_BY_TERM_SEARCH_SUCCEEDED = 'ORGANIZATION_FIND_BY_TERM_SEARCH_SUCCEEDED';
export const ORGANIZATION_FIND_BY_TERM_SEARCH_FAILED = 'ORGANIZATION_FIND_BY_TERM_SEARCH_FAILED';
export const ORGANIZATION_SELECT = 'ORGANIZATION_SELECT';
export const GET_ORGANIZATION_REQUESTED = 'GET_ORGANIZATION_REQUESTED';
export const GET_ORGANIZATION_SUCCEEDED = 'GET_ORGANIZATION_SUCCEEDED';
export const GET_ORGANIZATION_FAILED = 'GET_ORGANIZATION_FAILED';
export const GET_USER_LIMITS_REQUEST = 'GET_USER_LIMITS_REQUEST';
export const GET_USER_LIMITS_SUCCEEDED = 'GET_USER_LIMITS_SUCCEEDED';
export const GET_USER_LIMITS_FAILED = 'GET_USER_LIMITS_FAILED';
export const GET_USERS_LIMITS_REQUEST = 'GET_USERS_LIMITS_REQUEST';
export const GET_USERS_LIMITS_SUCCEEDED = 'GET_USERS_LIMITS_SUCCEEDED';
export const GET_USERS_LIMITS_FAILED = 'GET_USERS_LIMITS_FAILED';

//ORGANIZATION REGISTRATION GENERAL STATUS
export const GET_REGISTRATION_GENERAL_STATUS_REQUESTED = 'GET_REGISTRATION_GENERAL_STATUS_REQUESTED';
export const GET_REGISTRATION_GENERAL_STATUS_SUCCEEDED = 'GET_REGISTRATION_GENERAL_STATUS_SUCCEEDED';
export const GET_REGISTRATION_GENERAL_STATUS_FAILED = 'GET_REGISTRATION_GENERAL_STATUS_FAILED';

//ORGANIZATION REGISTRATION PARTICIPANT STATUS
export const GET_REGISTRATION_PARTICIPANT_STATUS_REQUESTED = 'GET_REGISTRATION_PARTICIPANT_STATUS_REQUESTED';
export const GET_REGISTRATION_PARTICIPANT_STATUS_SUCCEEDED = 'GET_REGISTRATION_PARTICIPANT_STATUS_SUCCEEDED';
export const GET_REGISTRATION_PARTICIPANT_STATUS_FAILED = 'GET_REGISTRATION_PARTICIPANT_STATUS_FAILED';


//ORGANIZATION REGISTRATION GENERAL COMMITMENT STATUS
export const GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_REQUESTED = 'GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_REQUESTED';
export const GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_SUCCEEDED = 'GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_SUCCEEDED';
export const GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_FAILED = 'GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_FAILED';

//ORGANIZATION REGISTRATION COMMITMENT STATUS
export const GET_REGISTRATION_COMMITMENT_STATUS_REQUESTED = 'GET_REGISTRATION_COMMITMENT_STATUS_REQUESTED';
export const GET_REGISTRATION_COMMITMENT_STATUS_SUCCEEDED = 'GET_REGISTRATION_COMMITMENT_STATUS_SUCCEEDED';
export const GET_REGISTRATION_COMMITMENT_STATUS_FAILED = 'GET_REGISTRATION_COMMITMENT_STATUS_FAILED';


export const UPDATE_USER_LIMITS_REQUEST = 'UPDATE_USER_LIMITS_REQUEST';
export const UPDATE_USER_LIMITS_SUCCEEDED = 'UPDATE_USER_LIMITS_SUCCEEDED';
export const UPDATE_USER_LIMITS_FAILED = 'UPDATE_USER_LIMITS_FAILED';

export const UPDATE_ORGANIZATION_LIMITS_REQUEST = 'UPDATE_ORGANIZATION_LIMITS_REQUEST';
export const UPDATE_ORGANIZATION_LIMITS_SUCCEEDED = 'UPDATE_ORGANIZATION_LIMITS_SUCCEEDED';
export const UPDATE_ORGANIZATION_LIMITS_FAILED = 'UPDATE_ORGANIZATION_LIMITS_FAILED';


// STATIONS
export const STATION_SEARCH_REQUESTED = 'STATION_SEARCH_REQUESTED';
export const STATION_SEARCH_SUCCEEDED = 'STATION_SEARCH_SUCCEEDED';
export const STATION_SEARCH_FAILED = 'STATION_SEARCH_FAILED';
export const GET_STATIONS_REQUESTED = 'GET_STATIONS_REQUESTED';
export const GET_STATIONS_SUCCEEDED = 'GET_STATIONS_SUCCEEDED';
export const GET_STATIONS_FAILED = 'GET_STATIONS_FAILED';
export const SET_STATIONS = 'SET_STATIONS';

// USERS
export const USER_SEARCH_REQUESTED = 'USER_SEARCH_REQUESTED';
export const USER_SEARCH_SUCCEEDED = 'USER_SEARCH_SUCCEEDED';
export const USER_SEARCH_FAILED = 'USER_SEARCH_FAILED';
export const USER_LOOKUP_REQUESTED = 'USER_LOOKUP_REQUESTED';
export const USER_LOOKUP_SUCCEEDED = 'USER_LOOKUP_SUCCEEDED';
export const USER_LOOKUP_FAILED = 'USER_LOOKUP_FAILED';

// HOMEPAGE
export const GET_MARKET_PROCESSES_LIST_REQUEST = 'GET_MARKET_PROCESSES_LIST_REQUEST';
export const GET_MARKET_PROCESSES_LIST_SUCCEEDED = 'GET_MARKET_PROCESSES_LIST_SUCCEEDED';
export const GET_MARKET_PROCESSES_LIST_FAILED = 'GET_MARKET_PROCESSES_LIST_FAILED';
export const GET_GENERAL_OPERATIONS_LIST_REQUEST = 'GET_GENERAL_OPERATIONS_LIST_REQUEST';
export const GET_GENERAL_OPERATIONS_LIST_SUCCEEDED = 'GET_GENERAL_OPERATIONS_LIST_SUCCEEDED';
export const GET_GENERAL_OPERATIONS_LIST_FAILED = 'GET_GENERAL_OPERATIONS_LIST_FAILED';
export const CLEAR_GENERAL_OPERATIONS_LIST = 'CLEAR_GENERAL_OPERATIONS_LIST';
export const SET_CHART_TERM = 'SET_CHART_TERM';
export const GET_CHART_DATA_REQUEST = 'GET_CHART_DATA_REQUEST';
export const GET_CHART_DATA_SUCCEEDED = 'GET_CHART_DATA_SUCCEEDED';
export const GET_CHART_DATA_FAILED = 'GET_CHART_DATA_FAILED';
export const GET_ORGANIZED_MARKET_INFO_REQUEST = 'GET_ORGANIZED_MARKET_INFO_REQUEST';
export const GET_ORGANIZED_MARKET_INFO_SUCCEEDED =  'GET_ORGANIZED_MARKET_INFO_SUCCEEDED';
export const GET_ORGANIZED_MARKET_INFO_FAILED = 'GET_ORGANIZED_MARKET_INFO_FAILED';
export const GET_SYSTEM_MSG_LIST_REQUEST = 'GET_SYSTEM_MSG_LIST_REQUEST';
export const GET_SYSTEM_MSG_LIST_SUCCEEDED = 'GET_SYSTEM_MSG_LIST_SUCCEEDED';
export const GET_SYSTEM_MSG_LIST_FAILED = 'GET_SYSTEM_MSG_LIST_FAILED';
export const GET_HOME_OBJECTIONS_LIST_REQUEST = 'GET_HOME_OBJECTIONS_LIST_REQUEST';
export const GET_HOME_OBJECTIONS_LIST_SUCCEEDED = 'GET_HOME_OBJECTIONS_LIST_SUCCEEDED';
export const GET_HOME_OBJECTIONS_LIST_FAILED = 'GET_HOME_OBJECTIONS_LIST_FAILED';
export const GET_HOME_BILATERAL_LIST_REQUEST = 'GET_HOME_BILATERAL_LIST_REQUEST';
export const GET_HOME_BILATERAL_LIST_SUCCEEDED = 'GET_HOME_BILATERAL_LIST_SUCCEEDED';
export const GET_HOME_BILATERAL_LIST_FAILED = 'GET_HOME_BILATERAL_LIST_FAILED';
export const GET_BILATERAL_SANDB_LIST_REQUEST = 'GET_BILATERAL_SANDB_LIST_REQUEST';
export const GET_BILATERAL_SANDB_LIST_SUCCEEDED = 'GET_BILATERAL_SANDB_LIST_SUCCEEDED';
export const GET_BILATERAL_SANDB_LIST_FAILED = 'GET_BILATERAL_SANDB_LIST_FAILED';
export const GET_HOME_PRODUCTION_DATA_REQUEST = 'GET_HOME_PRODUCTION_DATA_REQUEST';
export const GET_HOME_PRODUCTION_DATA_SUCCEEDED = 'GET_HOME_PRODUCTION_DATA_SUCCEEDED';
export const GET_HOME_PRODUCTION_DATA_FAILED = 'GET_HOME_PRODUCTION_DATA_FAILED';
export const GET_HOME_ACTIVE_CERTIFICATES_REQUEST = 'GET_HOME_ACTIVE_CERTIFICATES_REQUEST';
export const GET_HOME_ACTIVE_CERTIFICATES_SUCCEEDED = 'GET_HOME_ACTIVE_CERTIFICATES_SUCCEEDED';
export const GET_HOME_ACTIVE_CERTIFICATES_FAILED = 'GET_HOME_ACTIVE_CERTIFICATES_FAILED';

//COLLATERALS
export const GET_COLLATERALS_REQUESTED = 'GET_COLLATERALS_REQUESTED';
export const GET_COLLATERALS_SUCCEEDED = 'GET_COLLATERALS_SUCCEEDED';
export const GET_COLLATERALS_FAILED = 'GET_COLLATERALS_FAILED';
export const SET_COLLATERAL_FILTER_DATE = 'SET_COLLATERAL_FILTER_DATE';

//INVOİCE COLLATERAL REPORT
export const GET_INVOICE_COLLATERAL_REPORT_REQUESTED = 'GET_INVOICE_COLLATERAL_REPORT_REQUESTED';
export const GET_INVOICE_COLLATERAL_REPORT_SUCCEEDED = 'GET_INVOICE_COLLATERAL_REPORT_SUCCEEDED';
export const GET_INVOICE_COLLATERAL_REPORT_FAILED = 'GET_INVOICE_COLLATERAL_REPORT_FAILED';
export const SET_INVOICE_COLLATERAL_REPORT_FILTER_DATE = 'SET_INVOICE_COLLATERAL_REPORT_FILTER_DATE';

//SESSION COLLATERALS
export const GET_SESSION_COLLATERAL_REQUESTED = "GET_SESSION_COLLATERAL_REQUESTED";
export const GET_SESSION_COLLATERAL_SUCCEEDED = "GET_SESSION_COLLATERAL_SUCCEEDED";
export const GET_SESSION_COLLATERAL_FAILED = "GET_SESSION_COLLATERAL_FAILED";
export const SET_SESSION_COLLATERAL_FILTER_DATE = "SET_SESSION_COLLATERAL_FILTER_DATE"
export const GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_REQUESTED = "GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_REQUESTED";
export const GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_SUCCEEDED = "GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_SUCCEEDED";
export const GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_FAILED = "GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_FAILED";
export const GET_ALL_SESSIONS_REQUESTED = "GET_ALL_SESSIONS_REQUESTED";
export const GET_ALL_SESSIONS_SUCCEEDED = "GET_ALL_SESSIONS_SUCCEEDED";
export const GET_ALL_SESSIONS_FAILED = "GET_ALL_SESSIONS_FAILED";


//CERTIFICATES
export const GET_ACTIVE_CERTIFICATES_REQUESTED = 'GET_ACTIVE_CERTIFICATES_REQUESTED';
export const GET_ACTIVE_CERTIFICATES_SUCCEEDED = 'GET_ACTIVE_CERTIFICATES_SUCCEEDED';
export const GET_ACTIVE_CERTIFICATES_FAILED = 'GET_ACTIVE_CERTIFICATES_FAILED';

export const GET_SUSPENDED_CERTIFICATES_REQUESTED = 'GET_SUSPENDED_CERTIFICATES_REQUESTED';
export const GET_SUSPENDED_CERTIFICATES_SUCCEEDED = 'GET_SUSPENDED_CERTIFICATES_SUCCEEDED';
export const GET_SUSPENDED_CERTIFICATES_FAILED = 'GET_SUSPENDED_CERTIFICATES_FAILED';

export const GET_CANCELED_CERTIFICATES_REQUESTED = 'GET_CANCELED_CERTIFICATES_REQUESTED';
export const GET_CANCELED_CERTIFICATES_SUCCEEDED = 'GET_CANCELED_CERTIFICATES_SUCCEEDED';
export const GET_CANCELED_CERTIFICATES_FAILED = 'GET_CANCELED_CERTIFICATES_FAILED';

export const GET_REDEMPTION_USABLE_CERTIFICATES_REQUESTED = 'GET_REDEMPTION_USABLE_CERTIFICATES_REQUESTED';
export const GET_REDEMPTION_USABLE_CERTIFICATES_SUCCEEDED ='GET_REDEMPTION_USABLE_CERTIFICATES_SUCCEEDED';
export const GET_REDEMPTION_USABLE_CERTIFICATES_FAILED = 'GET_REDEMPTION_USABLE_CERTIFICATES_FAILED';

export const SET_CERTIFICATE_FILTER_STATION = 'SET_CERTIFICATE_FILTER_STATION';
export const SET_CERTIFICATE_FILTER_RESOURCE_TYPE = 'SET_CERTIFICATE_FILTER_RESOURCE_TYPE';
export const SET_CERTIFICATE_FILTER_PRODUCTION_PERIOD = 'SET_CERTIFICATE_FILTER_PRODUCTION_PERIOD';
export const SET_CERTIFICATE_FILTER_EXPORT_START_DATE = 'SET_CERTIFICATE_FILTER_EXPORT_START_DATE';
export const SET_CERTIFICATE_FILTER_EXPORT_END_DATE = 'SET_CERTIFICATE_FILTER_EXPORT_END_DATE';


// SESSIONS
export const GET_SESSION_REQUESTED = 'GET_SESSION_REQUESTED';
export const GET_SESSION_FAILED = 'GET_SESSION_FAILED';
export const GET_SESSIONS_REQUESTED = 'GET_SESSIONS_REQUESTED';
export const SET_SELECTED_SESSION_CONTRACTS = 'SET_SELECTED_SESSION_CONTRACTS';
export const GET_SESSIONS_SUCCEEDED = 'GET_SESSIONS_SUCCEEDED';
export const GET_SESSIONS_FAILED = 'GET_SESSIONS_FAILED';
export const GET_SIMPLIFIED_SESSIONS_REQUESTED = 'GET_SIMPLIFIED_SESSIONS_REQUESTED';
export const GET_SIMPLIFIED_SESSIONS_SUCCEEDED = 'GET_SIMPLIFIED_SESSIONS_SUCCEEDED';
export const GET_SIMPLIFIED_SESSIONS_FAILED = 'GET_SIMPLIFIED_SESSIONS_FAILED';
export const GET_CURRENT_SESSIONS_REQUESTED = 'GET_CURRENT_SESSIONS_REQUESTED';
export const GET_CURRENT_SESSIONS_SUCCEEDED = 'GET_CURRENT_SESSIONS_SUCCEEDED';
export const GET_CURRENT_SESSIONS_FAILED = 'GET_CURRENT_SESSIONS_FAILED';

// CONTRACTS
export const GET_ALL_CONTRACTS_REQUESTED = 'GET_ALL_CONTRACTS_REQUESTED';
export const GET_ALL_CONTRACTS_SUCCEEDED = 'GET_ALL_CONTRACTS_SUCCEEDED';
export const GET_ALL_CONTRACTS_FAILED = 'GET_ALL_CONTRACTS_FAILED';
export const SET_CONTRACT_FILTER = 'SET_CONTRACT_FILTER';
export const SET_CURRENT_CONTRACTS = 'SET_CURRENT_CONTRACTS';
export const REMOVE_CURRENT_CONTRACTS = 'REMOVE_CURRENT_CONTRACTS';
export const SET_CURRENT_CONTRACT_SELECTED = 'SET_CURRENT_CONTRACT_SELECTED';
export const SET_ALL_CONTRACT_SELECTED = 'SET_ALL_CONTRACT_SELECTED';

export const GET_CONTRACT_DEPTH_REQUESTED = 'GET_CONTRACT_DEPTH_REQUESTED';
export const GET_CONTRACT_DEPTH_SUCCEEDED = 'GET_CONTRACT_DEPTH_SUCCEEDED';
export const GET_CONTRACT_DEPTH_FAILED = 'GET_CONTRACT_DEPTH_FAILED';
// OFFERS
export const GET_MARKET_MATCHES_REQUESTED = 'GET_MARKET_MATCHES_REQUESTED';
export const GET_MARKET_MATCHES_SUCCEEDED = 'GET_MARKET_MATCHES_SUCCEEDED';
export const GET_MARKET_MATCHES_FAILED = 'GET_MARKET_MATCHES_FAILED';

//RESET OFFERS STATE
export const RESET_INITIAL_STATE = "RESET_INITIAL_STATE";

export const SET_MARKET_MATCHES_BUYER_ORGANIZATION = 'SET_MARKET_MATCHES_BUYER_ORGANIZATION';
export const SET_MARKET_MATCHES_SELLER_ORGANIZATION = 'SET_MARKET_MATCHES_SELLER_ORGANIZATION';

export const GET_SYSTEM_PARTICIPANT_MATCHES_REQUESTED = 'GET_SYSTEM_PARTICIPANT_MATCHES_REQUESTED';
export const GET_SYSTEM_PARTICIPANT_MATCHES_SUCCEEDED = 'GET_SYSTEM_PARTICIPANT_MATCHES_SUCCEEDED';
export const GET_SYSTEM_PARTICIPANT_MATCHES_FAILED = 'GET_SYSTEM_PARTICIPANT_MATCHES_FAILED';

export const GET_SYSTEM_PARTICIPANT_OFFERS_REQUESTED = 'GET_SYSTEM_PARTICIPANT_OFFERS_REQUESTED';
export const GET_SYSTEM_PARTICIPANT_OFFERS_SUCCEEDED = 'SEND_MARKET_CANCALLED_MATCHES_SUCCEEDED';
export const GET_SYSTEM_PARTICIPANT_OFFERS_FAILED = 'GET_SYSTEM_PARTICIPANT_OFFERS_FAILED';

export const SEND_MARKET_CANCELLED_MATCHES_REQUESTED = 'SEND_MARKET_CANCELLED_MATCHES_REQUESTED';
export const SEND_MARKET_CANCELLED_MATCHES_SUCCEEDED = 'SEND_MARKET_CANCELLED_MATCHES_SUCCEEDED';
export const SEND_MARKET_CANCELLED_MATCHES_FAILED = 'SEND_MARKET_CANCELLED_MATCHES_FAILED';
// EXCHANGE ORDERS
export const GET_ACTIVE_OFFERS_REQUESTED = 'GET_ACTIVE_OFFERS_REQUESTED';
export const GET_ACTIVE_OFFERS_SUCCEEDED = 'GET_ACTIVE_OFFERS_SUCCEEDED';
export const GET_ACTIVE_OFFERS_FAILED = 'GET_ACTIVE_OFFERS_FAILED';

export const BUY_ORDER_LIST_REQUESTED = 'BUY_ORDER_LIST_REQUESTED';
export const BUY_ORDER_LIST_SUCCEEDED = 'BUY_ORDER_LIST_SUCCEEDED';
export const BUY_ORDER_LIST_FAILED = 'BUY_ORDER_LIST_FAILED';

export const BUY_ORDER_REQUESTED = 'BUY_ORDER_REQUESTED';
export const BUY_ORDER_SUCCEEDED = 'BUY_ORDER_SUCCEEDED';
export const BUY_ORDER_FAILED = 'BUY_ORDER_FAILED';

export const SELL_ORDER_LIST_REQUESTED = 'SELL_ORDER_LIST_REQUESTED';
export const SELL_ORDER_LIST_SUCCEEDED = 'SELL_ORDER_LIST_SUCCEEDED';
export const SELL_ORDER_LIST_FAILED = 'SELL_ORDER_LIST_FAILED';

export const SELL_ORDER_REQUESTED = 'SELL_ORDER_REQUESTED';
export const SELL_ORDER_SUCCEEDED = 'SELL_ORDER_SUCCEEDED';
export const SELL_ORDER_FAILED = 'SELL_ORDER_FAILED';

// PRODUCTION_DATAS
export const GET_PRODUCTION_DATA_REQUESTED = 'GET_PRODUCTION_DATA_REQUESTED';
export const GET_PRODUCTION_DATA_SUCCEEDED = 'GET_PRODUCTION_DATA_SUCCEEDED';
export const GET_PRODUCTION_DATA_FAILED = 'GET_PRODUCTION_DATA_FAILED';

// UTILITIES
export const SET_NAVBAR_TOGGLE = 'SET_NAVBAR_TOGGLE';
export const SET_SERVER_TIME = 'SET_SERVER_TIME';
export const TICK_SERVER_TIME = 'TICK_SERVER_TIME';

// BILATERAL_AGREEMENTS
export const SET_SELECTED_TO_ORGANIZATION = 'SET_SELECTED_TO_ORGANIZATION';
export const GET_CERTIFICATES_REQUEST = 'GET_CERTIFICATES_REQUEST';
export const GET_CERTIFICATES_SUCCEEDED = 'GET_CERTIFICATES_SUCCEEDED';
export const GET_CERTIFICATES_FAILED = 'GET_CERTIFICATES_FAILED';
export const GET_BILATERAL_AGREEMENTS_REQUEST = 'GET_BILATERAL_AGREEMENTS_REQUEST';
export const GET_BILATERAL_AGREEMENTS_SUCCEEDED = 'GET_BILATERAL_AGREEMENTS_SUCCEEDED';
export const GET_BILATERAL_AGREEMENTS_FAILED = 'GET_BILATERAL_AGREEMENTS_FAILED';
export const GET_BILATERAL_AGREEMENTS_HISTORY_REQUEST = 'GET_BILATERAL_AGREEMENTS_HISTORY_REQUEST';
export const GET_BILATERAL_AGREEMENTS_HISTORY_SUCCEEDED = 'GET_BILATERAL_AGREEMENTS_HISTORY_SUCCEEDED';
export const GET_BILATERAL_AGREEMENTS_HISTORY_FAILED = 'GET_BILATERAL_AGREEMENTS_HISTORY_FAILED';
export const SET_SELECTED_SELLER_ORGANIZATION = 'SET_SELECTED_SELLER_ORGANIZATION';
export const SET_SELECTED_BUYER_ORGANIZATION = 'SET_SELECTED_BUYER_ORGANIZATION';
export const SET_SELECTED_DATE_WITH_ORGANIZATION = 'SET_SELECTED_DATE_WITH_ORGANIZATION';

// REDEMPTIONS
export const BENEFICIARY_ORGANIZATION_SELECT = 'BENEFICIARY_ORGANIZATION_SELECT';
export const HISTORY_ORGANIZATION_SELECT = 'HISTORY_ORGANIZATION_SELECT';
export const SET_ACTIVE_REDEMPTIONS_START_DATE = 'SET_ACTIVE_REDEMPTIONS_START_DATE';
export const SET_ACTIVE_REDEMPTIONS_END_DATE = 'SET_ACTIVE_REDEMPTIONS_END_DATE';
export const ACTIVE_REDEMPTIONS_SEARCH_REQUESTED = 'ACTIVE_REDEMPTIONS_SEARCH_REQUESTED';
export const ACTIVE_REDEMPTIONS_SEARCH_SUCCEEDED = 'ACTIVE_REDEMPTIONS_SEARCH_SUCCEEDED';
export const ACTIVE_REDEMPTIONS_SEARCH_FAILED = 'ACTIVE_REDEMPTIONS_SEARCH_FAILED';
export const HISTORY_REDEMPTIONS_SEARCH_REQUESTED = 'HISTORY_REDEMPTIONS_SEARCH_REQUESTED';
export const HISTORY_REDEMPTIONS_SEARCH_SUCCEEDED = 'HISTORY_REDEMPTIONS_SEARCH_SUCCEEDED';
export const HISTORY_REDEMPTIONS_SEARCH_FAILED = 'HISTORY_REDEMPTIONS_SEARCH_FAILED';
export const SET_REDEMPTIONS_HISTORY_START_DATE = 'SET_REDEMPTIONS_HISTORY_START_DATE';
export const SET_REDEMPTIONS_HISTORY_END_DATE = 'SET_REDEMPTIONS_HISTORY_END_DATE';
export const SET_REDEMPTIONS_HISTORY_STATUS = 'SET_REDEMPTIONS_HISTORY_STATUS';
export const SET_ACTIVE_REDEMPTIONS_TITLE = 'SET_ACTIVE_REDEMPTIONS_TITLE';
export const SET_REDEMPTIONS_HISTORY_TITLE = 'SET_REDEMPTIONS_HISTORY_TITLE';
export const SET_FILTER_CONSUMPTION_PERIOD = 'SET_FILTER_CONSUMPTION_PERIOD';
export const GET_CONSUMPTION_DATA_REQUESTED = 'GET_CONSUMPTION_DATA_REQUESTED';
export const GET_CONSUMPTION_DATA_SUCCEEDED = 'GET_CONSUMPTION_DATA_SUCCEEDED';
export const GET_CONSUMPTION_DATA_FAILED = 'GET_CONSUMPTION_DATA_FAILED';

// RECONCILIATION
export const SET_FILTER_PERIOD = 'SET_FILTER_PERIOD';
export const SET_INVOICE_FILTER_PERIOD = 'SET_INVOICE_FILTER_PERIOD';
export const GET_RECONCILIATION_INFO_REQUEST = 'GET_RECONCILIATION_INFO_REQUEST';
export const GET_RECONCILIATION_INFO_SUCCEEDED = 'GET_RECONCILIATION_INFO_SUCCEEDED';
export const GET_RECONCILIATION_INFO_FAILED = 'GET_RECONCILIATION_INFO_FAILED';
export const GET_RECONCILIATION_LIST_REQUEST = 'GET_RECONCILIATION_LIST_REQUEST';
export const GET_RECONCILIATION_LIST_SUCCEEDED = 'GET_RECONCILIATION_LIST_SUCCEEDED';
export const GET_RECONCILIATION_LIST_FAILED = 'GET_RECONCILIATION_LIST_FAILED';
export const SET_SELECTED_RECONCILIATION_ID = 'SET_SELECTED_RECONCILIATION_ID';
export const GET_SELECTED_RECONCILIATION_DETAILS_REQUEST = 'GET_SELECTED_RECONCILIATION_DETAILS_REQUEST';
export const GET_SELECTED_RECONCILIATION_DETAILS_SUCCEEDED = 'GET_SELECTED_RECONCILIATION_DETAILS_SUCCEEDED';
export const GET_SELECTED_RECONCILIATION_DETAILS_FAILED = 'GET_SELECTED_RECONCILIATION_DETAILS_FAILED';
export const GET_SELECTED_RECONCILIATION_ITEM_DETAILS_REQUEST = 'GET_SELECTED_RECONCILIATION_ITEM_DETAILS_REQUEST';
export const GET_SELECTED_RECONCILIATION_ITEM_DETAILS_SUCCEEDED = 'GET_SELECTED_RECONCILIATION_ITEM_DETAILS_SUCCEEDED';
export const GET_SELECTED_RECONCILIATION_ITEM_DETAILS_FAILED = 'GET_SELECTED_RECONCILIATION_ITEM_DETAILS_FAILED';
export const REMOVE_RECONCILIATION_ITEM_DETAILS = 'REMOVE_RECONCILIATION_ITEM_DETAILS';

export const CLEAR_SELECTED_RECONCILIATION = 'CLEAR_SELECTED_RECONCILIATION';
export const CLEAR_ITEM_DETAILS = 'CLEAR_ITEM_DETAILS';
export const CLEAR_INFO = 'CLEAR_INFO';

// OBJECTIONS
export const GET_OBJECTIONS_ORDER_MATCH_REQUESTED = 
    'GET_OBJECTIONS_ORDER_MATCH_REQUESTED';
export const GET_OBJECTIONS_ORDER_MATCH_SUCCEEDED = 
    'GET_OBJECTIONS_ORDER_MATCH_SUCCEEDED';
export const GET_OBJECTIONS_ORDER_MATCH_FAILED = 
    'GET_OBJECTIONS_ORDER_MATCH_FAILED';
export const GET_OBJECTIONS_REQUESTED = 'GET_OBJECTIONS_REQUESTED';
export const GET_OBJECTIONS_SUCCEEDED = 'GET_OBJECTIONS_SUCCEEDED';
export const GET_OBJECTIONS_FAILED = 'GET_OBJECTIONS_FAILED';
export const GET_OBJECTIONS_HISTORY_REQUESTED = 'GET_OBJECTIONS_HISTORY_REQUESTED';
export const GET_OBJECTIONS_HISTORY_SUCCEEDED = 'GET_OBJECTIONS_HISTORY_SUCCEEDED';
export const GET_OBJECTIONS_HISTORY_FAILED = 'GET_OBJECTIONS_HISTORY_FAILED';
export const SET_OBJECTIONS_FILTER = 'SET_OBJECTIONS_FILTER';
export const SET_OBJECTIONS_HISTORY_FILTER = 'SET_OBJECTIONS_HISTORY_FILTER';
export const SET_OBJECTIONS_FILTER_ORGANIZATION = 'SET_OBJECTIONS_FILTER_ORGANIZATION';
export const SET_OBJECTIONS_HISTORY_FILTER_ORGANIZATION = 'SET_OBJECTIONS_HISTORY_FILTER_ORGANIZATION';

// GDDK
export const SET_GDDK_FILTER_STATION = 'SET_GDDK_FILTER_STATION';
export const SET_GDDK_FILTER_RESOURCE_TYPE =  'SET_GDDK_FILTER_RESOURCE_TYPE';
export const SET_GDDK_FILTER_GDDK_PERIOD =  'SET_GDDK_FILTER_PRODUCTION_PERIOD';
export const GET_ACTIVE_GDDK_LIST_REQUEST =  'GET_ACTIVE_GDDK_LIST_REQUEST';
export const GET_ACTIVE_GDDK_LIST_SUCCEEDED =  'GET_ACTIVE_GDDK_LIST_SUCCEEDED';
export const GET_ACTIVE_GDDK_LIST_FAILED =  'GET_ACTIVE_GDDK_LIST_FAILED';
export const SET_HISTORY_GDDK_FILTER_RESOURCE_TYPE =  'SET_HISTORY_GDDK_FILTER_RESOURCE_TYPE';
export const SET_HISTORY_GDDK_FILTER_GDDK_PERIOD =  'SET_HISTORY_GDDK_FILTER_GDDK_PERIOD';
export const GET_GDDK_HISTORY_LIST_REQUEST = 'GET_GDDK_HISTORY_LIST_REQUEST';
export const GET_GDDK_HISTORY_LIST_SUCCEEDED = 'GET_GDDK_HISTORY_LIST_SUCCEEDED';
export const GET_GDDK_HISTORY_LIST_FAILED =  'GET_GDDK_HISTORY_LIST_FAILED';
export const SET_GDDK_FILTER_CONSUMPTION_PERIOD = 'SET_GDDK_FILTER_CONSUMPTION_PERIOD';
export const GET_GDDK_CONSUMPTION_LIST_REQUEST = 'GET_GDDK_CONSUMPTION_LIST_REQUEST';
export const GET_GDDK_CONSUMPTION_LIST_SUCCEEDED = 'GET_GDDK_CONSUMPTION_LIST_SUCCEEDED';
export const GET_GDDK_CONSUMPTION_LIST_FAILED = 'GET_GDDK_CONSUMPTION_LIST_FAILED';

// OPERATION HISTORY
export const SET_OPERATION_HISTORY_SELECTED_ORGANIZATION = 'SET_OPERATION_HISTORY_SELECTED_ORGANIZATION';
export const SET_OPERATION_HISTORY_SELECTED_USER = 'SET_OPERATION_HISTORY_SELECTED_USER';
export const SET_FILTERED_OPERATION_TYPE = 'SET_FILTERED_OPERATION_TYPE';
export const SET_FILTERED_IMPORTANCE = 'SET_FILTERED_IMPORTANCE';
export const SET_FILTERED_SUBJECT = 'SET_FILTERED_SUBJECT';
export const GET_OPERATION_HISTORY_LIST_REQUEST = 'GET_OPERATION_HISTORY_LIST_REQUEST';
export const GET_OPERATION_HISTORY_LIST_SUCCEEDED = 'GET_OPERATION_HISTORY_LIST_SUCCEEDED';
export const GET_OPERATION_HISTORY_LIST_FAILED = 'GET_OPERATION_HISTORY_LIST_FAILED';

// NOTIFICATION
export const GET_NOTIFICATION_SETTINGS_REQUEST = 'GET_NOTIFICATION_SETTINGS_REQUEST';
export const GET_NOTIFICATION_SETTINGS_SUCCEEDED = 'GET_NOTIFICATION_SETTINGS_SUCCEEDED';
export const GET_NOTIFICATION_SETTINGS_FAILED = 'GET_NOTIFICATION_SETTINGS_FAILED';
export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCEEDED = 'GET_NOTIFICATIONS_SUCCEEDED';
export const GET_NOTIFICATIONS_FAILED = 'GET_NOTIFICATIONS_FAILED';
export const GET_MENU_NOTIFICATIONS_REQUEST = 'GET_MENU_NOTIFICATIONS_REQUEST';
export const GET_MENU_NOTIFICATIONS_SUCCEEDED = 'GET_MENU_NOTIFICATIONS_SUCCEEDED';
export const GET_MENU_NOTIFICATIONS_FAILED = 'GET_MENU_NOTIFICATIONS_FAILED';

// PORTAL
export const SET_PORTAL_DATA = "SET_PORTAL_DATA";

// GEO
export const GET_CITIES_REQUEST = "GET_CITIES_REQUEST";
export const GET_CITIES_SUCCEEDED = "GET_CITIES_SUCCEEDED";
export const GET_CITIES_FAILED = "GET_CITIES_FAILED";
export const SET_SELECTED_CITY = "SET_SELECTED_CITY";

export const GET_DISTRICTS_REQUEST = "GET_DISTRICTS_REQUEST";
export const GET_DISTRICTS_SUCCEEDED = "GET_DISTRICTS_SUCCEEDED";
export const GET_DISTRICTS_FAILED = "GET_CITIES_FAILED";
export const SET_SELECTED_DISTRICT = "SET_SELECTED_DISTRICT";